module.exports = __webpack_public_path__ + "img/receipt.245620e5.svg";